import React, { useMemo, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../_metronic/_partials/controls";
import { BusinessesFilter } from "./businesses-filter/BusinessesFilter";
import { BusinessesTable } from "./businesses-table/BusinessesTable";
import { BusinessesGrouping } from "./businesses-grouping/BusinessesGrouping";
import { useBusinessesUIContext } from "./BusinessesUIContext";
import { useSubheader } from "../../../../../_metronic/layout";

export function BusinessesCard() {
  const {user} = useSelector(state => state.auth);
  const userobject = user.userData;
  var superadmin = true;
  if (userobject.admin_role && userobject.admin_role !== 'superadmin' && userobject.is_admin) { superadmin = false; }

  const navigate = useNavigate();
  const location = useLocation();
  const subheader = useSubheader();

  useEffect(() => {
    subheader.setTitle("Businesses");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if(location.pathname.split("/")[2])
  {
    var tab = location.pathname.split("/")[2];
  }
  else{
    tab="all"
  }
  const callFilterFunction = (val) => {
    if(val==="all")       { navigate(`/business/`); }
    if(val==="approved")  { navigate(`/business/approved`); }
    if(val==="pending")   { navigate(`/business/pending`); }
    if(val==="rejected")  { navigate(`/business/rejected`); }
    if(val==="draft")     { navigate(`/business/draft`); }
  };
  const businessesUIContext = useBusinessesUIContext();
  const businessesUIProps = useMemo(() => {
    return {
      ids: businessesUIContext.ids,
      queryParams: businessesUIContext.queryParams,
      setQueryParams: businessesUIContext.setQueryParams,
      newBusinessButtonClick: businessesUIContext.newBusinessButtonClick,
      openDeleteBusinessesDialog: businessesUIContext.openDeleteBusinessesDialog,
      openEditBusinessPage: businessesUIContext.openEditBusinessPage,
      openUpdateBusinessesStatusDialog:
        businessesUIContext.openUpdateBusinessesStatusDialog,
      openFetchBusinessesDialog: businessesUIContext.openFetchBusinessesDialog,
    };
  }, [businessesUIContext]);
  return (
    <Card>
      <CardHeader title="Business List">
        <CardHeaderToolbar>
          {superadmin && (
            <button
              type="button"
              className="btn btn-primary"
              onClick={businessesUIProps.newBusinessButtonClick}
            >
              New Business
            </button>
          )}
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <BusinessesFilter />
        {businessesUIProps.ids.length > 0  && superadmin && (
          <>
            <BusinessesGrouping />
          </>
        )}
        <ul className="nav nav-tabs nav-tabs-line nav-tabs-pill mb-4" role="tablist">
            <li className="nav-item">
              <a
                href="/business/"
                onClick={(e) => { e.preventDefault(); callFilterFunction("all"); }}
                className={`nav-link ${tab === "all" && "active"}`}
                data-toggle="tab"
                role="tab"
                aria-selected={(tab === "all").toString()}
              >
                All
              </a>
            </li>
            <li className="nav-item">
              <a
                href="/business/approved"
                onClick={(e) => { e.preventDefault(); callFilterFunction("approved"); }}
                className={`nav-link ${tab === "approved" && "active"}`}
                data-toggle="tab"
                role="tab"
                aria-selected={(tab === "approved").toString()}
              >
                Approved
              </a>
            </li>
            <li className="nav-item">
              <a
                href="/business/pending"
                onClick={(e) => { e.preventDefault(); callFilterFunction("pending"); }}
                className={`nav-link ${tab === "pending" && "active"}`}
                data-toggle="tab"
                role="tab"
                aria-selected={(tab === "pending").toString()}
              >
                Pending
              </a>
            </li>
            <li className="nav-item">
              <a
                href="/business/rejected"
                onClick={(e) => { e.preventDefault(); callFilterFunction("rejected"); }}
                className={`nav-link ${tab === "rejected" && "active"}`}
                data-toggle="tab"
                role="tab"
                aria-selected={(tab === "rejected").toString()}
              >
                Rejected
              </a>
            </li>
            <li className="nav-item">
              <a
                href="/business/draft"
                onClick={(e) => { e.preventDefault(); callFilterFunction("draft"); }}
                className={`nav-link ${tab === "draft" && "active"}`}
                data-toggle="tab"
                role="tab"
                aria-selected={(tab === "draft").toString()}
              >
                Draft
              </a>
            </li>
          </ul>
         
        <BusinessesTable />
      </CardBody>
    </Card>
  );
}
